import { StyledModalOverlay, StyledModalT1 } from "./Modal.styles";
import { useCallback } from "react";

/**
 * ModalOverlay
 *
 * Wraps modal content in a styled overlay and forwards click events.
 *
 * Params
 * - children (React.ReactNode): The modal content to render inside the overlay.
 * - onClickCallback (function): Handler invoked when the overlay is clicked.
 * - ...rest (object): Additional props forwarded to the StyledModalOverlay.
 *
 * Returns
 * - React.ReactElement: A StyledModalOverlay containing the children.
 */
const ModalOverlay = ({ children, onClickCallback = () => {}, ...rest }) => {
  const handleClick = useCallback(e => onClickCallback(e), [onClickCallback]);

  return (
    <StyledModalOverlay {...rest} onClick={handleClick}>
      {children}
    </StyledModalOverlay>
  );
};

/**
 * ModalT1
 *
 * Styled container for modal content, controlling size and layout.
 *
 * Params
 * - children (React.ReactNode): The content to render inside the modal container.
 * - ...rest (object): Additional props forwarded to the StyledModalT1.
 *
 * Returns
 * - React.ReactElement: A StyledModalT1 wrapping the provided children.
 */

const ModalT1 = ({ children, ...rest }) => {
  return <StyledModalT1 {...rest}>{children}</StyledModalT1>;
};

export { ModalOverlay, ModalT1 };
